import { api } from './client';

export interface OrgMaxStatus {
  enabled: boolean;
  linked: boolean;
  chat_id: string | null;
  linked_at: string | null;
  pending_code: string | null;
  pending_expires_at: string | null;
  bot_username: string;
}

export interface OrgMaxLinkOut {
  code: string;
  expires_at: string;
  bot_username: string;
  deep_link: string;
}

export const orgMaxApi = {
  status: (orgId: string) =>
    api.get<OrgMaxStatus>(`/api/v1/organizations/${orgId}/max/status`).then(r => r.data),
  link: (orgId: string) =>
    api.post<OrgMaxLinkOut>(`/api/v1/organizations/${orgId}/max/link`).then(r => r.data),
  unlink: (orgId: string) =>
    api.post(`/api/v1/organizations/${orgId}/max/unlink`),
};
